// generated from 03_数据面板坐标映射.json
export const layoutData = {
  "page": "tabPage2（标题：数据面板）",
  "design_canvas_px": [
    1884,
    885
  ],
  "note": "所有坐标 = WinForms 设计器里的绝对像素；归一化坐标以底图 pictureBox 左上角为原点。网页端做法：把底图作为背景，控件按 norm_x/norm_y/norm_w/norm_h 乘以容器尺寸绝对定位即可 1:1 复现。",
  "background": {
    "file": "assets/系统流程图_底图.jpg",
    "original_px": [
      11944,
      5731
    ],
    "control_px": [
      1911,
      917
    ],
    "control_origin_in_tabpage": [
      -24,
      -32
    ],
    "sizemode": "Zoom (等比填满 1911x917；底图纵横比 2.084 与控件一致，无留白)"
  },
  "overlay_count": 89,
  "overlays": [
    {
      "control": "levelGauge3",
      "x": 953,
      "y": 191,
      "w": 7,
      "h": 136,
      "norm_x": 0.51125,
      "norm_y": 0.24318,
      "norm_w": 0.00366,
      "norm_h": 0.14831,
      "text_static": "levelGauge3",
      "kind": "level_gauge",
      "channel_key": "A4_13",
      "channel_hardware": "A4-13",
      "data_array": "analog",
      "data_index": 13,
      "unit": "mm",
      "semantics": "竖直液位条，Value=值/满量程*100"
    },
    {
      "control": "levelGauge2",
      "x": 1196,
      "y": 626,
      "w": 7,
      "h": 153,
      "norm_x": 0.63841,
      "norm_y": 0.71756,
      "norm_w": 0.00366,
      "norm_h": 0.16685,
      "text_static": "levelGauge2",
      "kind": "level_gauge",
      "channel_key": "A4_12",
      "channel_hardware": "A4-12",
      "data_array": "analog",
      "data_index": 12,
      "unit": "mm",
      "semantics": "竖直液位条，Value=值/满量程*100"
    },
    {
      "control": "levelGauge1",
      "x": 569,
      "y": 625,
      "w": 7,
      "h": 153,
      "norm_x": 0.31031,
      "norm_y": 0.71647,
      "norm_w": 0.00366,
      "norm_h": 0.16685,
      "text_static": "levelGauge1",
      "kind": "level_gauge",
      "channel_key": "A4_11",
      "channel_hardware": "A4-11",
      "data_array": "analog",
      "data_index": 11,
      "unit": "mm",
      "semantics": "竖直液位条，Value=值/满量程*100"
    },
    {
      "control": "label_T_6_2",
      "x": 1327,
      "y": 734,
      "w": 40,
      "h": 12,
      "norm_x": 0.70696,
      "norm_y": 0.83533,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_15",
      "channel_hardware": "T2-15",
      "data_array": "temp",
      "data_index": 15,
      "unit": "℃"
    },
    {
      "control": "label_T_6_1",
      "x": 1327,
      "y": 708,
      "w": 40,
      "h": 12,
      "norm_x": 0.70696,
      "norm_y": 0.80698,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_14",
      "channel_hardware": "T2-14",
      "data_array": "temp",
      "data_index": 14,
      "unit": "℃"
    },
    {
      "control": "label_T_5_8",
      "x": 1327,
      "y": 681,
      "w": 40,
      "h": 12,
      "norm_x": 0.70696,
      "norm_y": 0.77754,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_15",
      "channel_hardware": "T3-15",
      "data_array": "temp",
      "data_index": 15,
      "unit": "℃"
    },
    {
      "control": "camBox2",
      "x": 1370,
      "y": 467,
      "w": 189,
      "h": 131,
      "norm_x": 0.72946,
      "norm_y": 0.54417,
      "norm_w": 0.0989,
      "norm_h": 0.14286,
      "text_static": "",
      "kind": "camera",
      "semantics": "摄像头3"
    },
    {
      "control": "camBox1",
      "x": 889,
      "y": 355,
      "w": 189,
      "h": 131,
      "norm_x": 0.47776,
      "norm_y": 0.42203,
      "norm_w": 0.0989,
      "norm_h": 0.14286,
      "text_static": "",
      "kind": "camera",
      "semantics": "摄像头2"
    },
    {
      "control": "camBox",
      "x": 711,
      "y": 730,
      "w": 189,
      "h": 131,
      "norm_x": 0.38462,
      "norm_y": 0.83097,
      "norm_w": 0.0989,
      "norm_h": 0.14286,
      "text_static": "",
      "kind": "camera",
      "semantics": "摄像头1（0.5s 轮流开）"
    },
    {
      "control": "label_T_5_7",
      "x": 1680,
      "y": 619,
      "w": 40,
      "h": 12,
      "norm_x": 0.89168,
      "norm_y": 0.70992,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_14",
      "channel_hardware": "T3-14",
      "data_array": "temp",
      "data_index": 14,
      "unit": "℃"
    },
    {
      "control": "label_F_5_1",
      "x": 1676,
      "y": 701,
      "w": 40,
      "h": 12,
      "norm_x": 0.88959,
      "norm_y": 0.79935,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_15",
      "channel_hardware": "A4-15",
      "data_array": "analog",
      "data_index": 15,
      "unit": null
    },
    {
      "control": "label_T_5_6",
      "x": 1620,
      "y": 749,
      "w": 40,
      "h": 12,
      "norm_x": 0.86028,
      "norm_y": 0.85169,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_13",
      "channel_hardware": "T3-13",
      "data_array": "temp",
      "data_index": 13,
      "unit": "℃"
    },
    {
      "control": "label_T_5_5",
      "x": 1626,
      "y": 821,
      "w": 40,
      "h": 12,
      "norm_x": 0.86342,
      "norm_y": 0.93021,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_12",
      "channel_hardware": "T3-12",
      "data_array": "temp",
      "data_index": 12,
      "unit": "℃"
    },
    {
      "control": "label_T_5_3",
      "x": 1475,
      "y": 748,
      "w": 40,
      "h": 12,
      "norm_x": 0.78441,
      "norm_y": 0.8506,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_10",
      "channel_hardware": "T3-10",
      "data_array": "temp",
      "data_index": 10,
      "unit": "℃"
    },
    {
      "control": "label_T_5_4",
      "x": 1475,
      "y": 821,
      "w": 40,
      "h": 12,
      "norm_x": 0.78441,
      "norm_y": 0.93021,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_11",
      "channel_hardware": "T3-11",
      "data_array": "temp",
      "data_index": 11,
      "unit": "℃"
    },
    {
      "control": "TowerFanPic",
      "x": 21,
      "y": 15,
      "w": 62,
      "h": 57,
      "norm_x": 0.02355,
      "norm_y": 0.05125,
      "norm_w": 0.03244,
      "norm_h": 0.06216,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev0",
      "bit": "bit3 塔风机",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "LoopPumpPic",
      "x": 33,
      "y": 110,
      "w": 40,
      "h": 40,
      "norm_x": 0.02983,
      "norm_y": 0.15485,
      "norm_w": 0.02093,
      "norm_h": 0.04362,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev0",
      "bit": "bit5 循环水泵",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "TowerPumpPic",
      "x": 251,
      "y": 14,
      "w": 40,
      "h": 40,
      "norm_x": 0.1439,
      "norm_y": 0.05016,
      "norm_w": 0.02093,
      "norm_h": 0.04362,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev0",
      "bit": "bit4 塔水泵",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "AirPic",
      "x": 108,
      "y": 470,
      "w": 70,
      "h": 57,
      "norm_x": 0.06907,
      "norm_y": 0.54744,
      "norm_w": 0.03663,
      "norm_h": 0.06216,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev0",
      "bit": "bit2 鼓风机",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "PoorPumpPic",
      "x": 1053,
      "y": 728,
      "w": 78,
      "h": 70,
      "norm_x": 0.56358,
      "norm_y": 0.82879,
      "norm_w": 0.04082,
      "norm_h": 0.07634,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev0",
      "bit": "bit0 贫液泵",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "RichPumpPic",
      "x": 635,
      "y": 729,
      "w": 68,
      "h": 70,
      "norm_x": 0.34485,
      "norm_y": 0.82988,
      "norm_w": 0.03558,
      "norm_h": 0.07634,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev0",
      "bit": "bit1 富液泵",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "RefluxPumpPic1",
      "x": 755,
      "y": 317,
      "w": 40,
      "h": 40,
      "norm_x": 0.40764,
      "norm_y": 0.38059,
      "norm_w": 0.02093,
      "norm_h": 0.04362,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev1",
      "bit": "bit4 吸收塔回流泵",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "RefluxPumpPic2",
      "x": 1099,
      "y": 316,
      "w": 40,
      "h": 40,
      "norm_x": 0.58765,
      "norm_y": 0.3795,
      "norm_w": 0.02093,
      "norm_h": 0.04362,
      "text_static": "",
      "kind": "device_icon",
      "source": "dev1",
      "bit": "bit5 解吸塔回流泵",
      "semantics": "按位显隐：位=1 显示图标，=0 隐藏"
    },
    {
      "control": "LiquidLevel_ds_high",
      "x": 953,
      "y": 279,
      "w": 6,
      "h": 35,
      "norm_x": 0.51125,
      "norm_y": 0.33915,
      "norm_w": 0.00314,
      "norm_h": 0.03817,
      "text_static": " ",
      "kind": "legacy_unused",
      "semantics": "解吸塔液位开关(旧电容式，已废弃)"
    },
    {
      "control": "LiquidLevel_ab_high",
      "x": 889,
      "y": 280,
      "w": 6,
      "h": 35,
      "norm_x": 0.47776,
      "norm_y": 0.34024,
      "norm_w": 0.00314,
      "norm_h": 0.03817,
      "text_static": " ",
      "kind": "legacy_unused",
      "semantics": "吸收塔液位开关(旧电容式，已废弃)"
    },
    {
      "control": "LiquidLevel_ds_low",
      "x": 953,
      "y": 314,
      "w": 6,
      "h": 12,
      "norm_x": 0.51125,
      "norm_y": 0.37732,
      "norm_w": 0.00314,
      "norm_h": 0.01309,
      "text_static": " ",
      "kind": "legacy_unused",
      "semantics": "解吸塔液位开关(旧电容式，已废弃)"
    },
    {
      "control": "LiquidLevel_ab_low",
      "x": 889,
      "y": 315,
      "w": 6,
      "h": 12,
      "norm_x": 0.47776,
      "norm_y": 0.37841,
      "norm_w": 0.00314,
      "norm_h": 0.01309,
      "text_static": " ",
      "kind": "legacy_unused",
      "semantics": "吸收塔液位开关(旧电容式，已废弃)"
    },
    {
      "control": "dataTime",
      "x": 1551,
      "y": 0,
      "w": 337,
      "h": 31,
      "norm_x": 0.82418,
      "norm_y": 0.0349,
      "norm_w": 0.17635,
      "norm_h": 0.03381,
      "text_static": "yyyy年MM月dd日 HH:mm:ss",
      "kind": "clock",
      "semantics": "当前数据时间戳，实时=绿 回放=橙"
    },
    {
      "control": "label_T_3_6",
      "x": 1756,
      "y": 341,
      "w": 40,
      "h": 12,
      "norm_x": 0.93145,
      "norm_y": 0.40676,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_19",
      "channel_hardware": "T1-19",
      "data_array": "temp",
      "data_index": 19,
      "unit": "℃"
    },
    {
      "control": "label_T_3_5",
      "x": 1779,
      "y": 446,
      "w": 40,
      "h": 12,
      "norm_x": 0.94349,
      "norm_y": 0.52126,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_18",
      "channel_hardware": "T1-18",
      "data_array": "temp",
      "data_index": 18,
      "unit": "℃"
    },
    {
      "control": "label_T_3_4",
      "x": 1651,
      "y": 514,
      "w": 40,
      "h": 12,
      "norm_x": 0.8765,
      "norm_y": 0.59542,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_17",
      "channel_hardware": "T1-17",
      "data_array": "temp",
      "data_index": 17,
      "unit": "℃"
    },
    {
      "control": "label_T_1_2",
      "x": 244,
      "y": 695,
      "w": 40,
      "h": 12,
      "norm_x": 0.14024,
      "norm_y": 0.7928,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_1",
      "channel_hardware": "T1-1",
      "data_array": "temp",
      "data_index": 1,
      "unit": "℃"
    },
    {
      "control": "label_T_1_1",
      "x": 225,
      "y": 605,
      "w": 40,
      "h": 12,
      "norm_x": 0.1303,
      "norm_y": 0.69466,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_0",
      "channel_hardware": "T1-0",
      "data_array": "temp",
      "data_index": 0,
      "unit": "℃"
    },
    {
      "control": "label_F_4_4",
      "x": 281,
      "y": 142,
      "w": 40,
      "h": 12,
      "norm_x": 0.1596,
      "norm_y": 0.18975,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_8",
      "channel_hardware": "A4-8",
      "data_array": "analog",
      "data_index": 8,
      "unit": null
    },
    {
      "control": "label_F_4_3",
      "x": 327,
      "y": 432,
      "w": 40,
      "h": 12,
      "norm_x": 0.18367,
      "norm_y": 0.506,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_7",
      "channel_hardware": "A4-7",
      "data_array": "analog",
      "data_index": 7,
      "unit": null
    },
    {
      "control": "label_F_4_2",
      "x": 326,
      "y": 354,
      "w": 40,
      "h": 12,
      "norm_x": 0.18315,
      "norm_y": 0.42094,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_6",
      "channel_hardware": "A4-6",
      "data_array": "analog",
      "data_index": 6,
      "unit": null
    },
    {
      "control": "label_F_4_1",
      "x": 326,
      "y": 276,
      "w": 40,
      "h": 12,
      "norm_x": 0.18315,
      "norm_y": 0.33588,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_5",
      "channel_hardware": "A4-5",
      "data_array": "analog",
      "data_index": 5,
      "unit": null
    },
    {
      "control": "label_F_4_5",
      "x": 326,
      "y": 198,
      "w": 40,
      "h": 12,
      "norm_x": 0.18315,
      "norm_y": 0.25082,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_9",
      "channel_hardware": "A4-9",
      "data_array": "analog",
      "data_index": 9,
      "unit": null
    },
    {
      "control": "label_F_3_1",
      "x": 1256,
      "y": 158,
      "w": 40,
      "h": 12,
      "norm_x": 0.66981,
      "norm_y": 0.2072,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_4",
      "channel_hardware": "A4-4",
      "data_array": "analog",
      "data_index": 4,
      "unit": null
    },
    {
      "control": "label_T_2_4",
      "x": 1145,
      "y": 802,
      "w": 40,
      "h": 12,
      "norm_x": 0.61172,
      "norm_y": 0.90949,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_6",
      "channel_hardware": "T1-6",
      "data_array": "temp",
      "data_index": 6,
      "unit": "℃"
    },
    {
      "control": "label_T_3_1",
      "x": 1596,
      "y": 157,
      "w": 40,
      "h": 12,
      "norm_x": 0.84772,
      "norm_y": 0.20611,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_14",
      "channel_hardware": "T1-14",
      "data_array": "temp",
      "data_index": 14,
      "unit": "℃"
    },
    {
      "control": "label_T_2_3",
      "x": 1161,
      "y": 520,
      "w": 40,
      "h": 12,
      "norm_x": 0.62009,
      "norm_y": 0.60196,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_5",
      "channel_hardware": "T1-5",
      "data_array": "temp",
      "data_index": 5,
      "unit": "℃"
    },
    {
      "control": "label_T_3_3",
      "x": 1650,
      "y": 323,
      "w": 40,
      "h": 12,
      "norm_x": 0.87598,
      "norm_y": 0.38713,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_16",
      "channel_hardware": "T1-16",
      "data_array": "temp",
      "data_index": 16,
      "unit": "℃"
    },
    {
      "control": "label_T_3_2",
      "x": 1585,
      "y": 245,
      "w": 40,
      "h": 12,
      "norm_x": 0.84197,
      "norm_y": 0.30207,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_15",
      "channel_hardware": "T1-15",
      "data_array": "temp",
      "data_index": 15,
      "unit": "℃"
    },
    {
      "control": "label_P_3_1",
      "x": 1648,
      "y": 156,
      "w": 40,
      "h": 12,
      "norm_x": 0.87493,
      "norm_y": 0.20502,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "deprecated_pressure",
      "semantics": "★不要复现为压力★ 原按 A4-11..A4-14 当压力显示；这三路已改液位、A4-14 属未启用压缩机。源码保留控件原样但不再刷新，网页端应留空或删除"
    },
    {
      "control": "label_P_3_2",
      "x": 1648,
      "y": 246,
      "w": 40,
      "h": 12,
      "norm_x": 0.87493,
      "norm_y": 0.30316,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "deprecated_pressure",
      "semantics": "★不要复现为压力★ 原按 A4-11..A4-14 当压力显示；这三路已改液位、A4-14 属未启用压缩机。源码保留控件原样但不再刷新，网页端应留空或删除"
    },
    {
      "control": "label_T_5_1",
      "x": 1390,
      "y": 679,
      "w": 40,
      "h": 12,
      "norm_x": 0.73993,
      "norm_y": 0.77535,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_12",
      "channel_hardware": "T2-12",
      "data_array": "temp",
      "data_index": 12,
      "unit": "℃"
    },
    {
      "control": "label_T_5_2",
      "x": 1388,
      "y": 771,
      "w": 40,
      "h": 12,
      "norm_x": 0.73888,
      "norm_y": 0.87568,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_13",
      "channel_hardware": "T2-13",
      "data_array": "temp",
      "data_index": 13,
      "unit": "℃"
    },
    {
      "control": "label_T_2_10",
      "x": 1175,
      "y": 221,
      "w": 40,
      "h": 12,
      "norm_x": 0.62742,
      "norm_y": 0.2759,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_12",
      "channel_hardware": "T1-12",
      "data_array": "temp",
      "data_index": 12,
      "unit": "℃"
    },
    {
      "control": "label_T_2_11",
      "x": 1051,
      "y": 221,
      "w": 40,
      "h": 12,
      "norm_x": 0.56253,
      "norm_y": 0.2759,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_13",
      "channel_hardware": "T1-13",
      "data_array": "temp",
      "data_index": 13,
      "unit": "℃"
    },
    {
      "control": "label_T_2_30",
      "x": 456,
      "y": 258,
      "w": 40,
      "h": 12,
      "norm_x": 0.25118,
      "norm_y": 0.31625,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_5",
      "channel_hardware": "T3-5",
      "data_array": "temp",
      "data_index": 5,
      "unit": "℃"
    },
    {
      "control": "label_T_2_31",
      "x": 456,
      "y": 347,
      "w": 40,
      "h": 12,
      "norm_x": 0.25118,
      "norm_y": 0.4133,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_6",
      "channel_hardware": "T3-6",
      "data_array": "temp",
      "data_index": 6,
      "unit": "℃"
    },
    {
      "control": "label_T_2_32",
      "x": 456,
      "y": 435,
      "w": 40,
      "h": 12,
      "norm_x": 0.25118,
      "norm_y": 0.50927,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_7",
      "channel_hardware": "T3-7",
      "data_array": "temp",
      "data_index": 7,
      "unit": "℃"
    },
    {
      "control": "label_T_2_33",
      "x": 456,
      "y": 523,
      "w": 40,
      "h": 12,
      "norm_x": 0.25118,
      "norm_y": 0.60523,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_8",
      "channel_hardware": "T3-8",
      "data_array": "temp",
      "data_index": 8,
      "unit": "℃"
    },
    {
      "control": "label_T_2_34",
      "x": 456,
      "y": 612,
      "w": 40,
      "h": 12,
      "norm_x": 0.25118,
      "norm_y": 0.70229,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_9",
      "channel_hardware": "T3-9",
      "data_array": "temp",
      "data_index": 9,
      "unit": "℃"
    },
    {
      "control": "label_T_2_1",
      "x": 587,
      "y": 802,
      "w": 40,
      "h": 12,
      "norm_x": 0.31973,
      "norm_y": 0.90949,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_3",
      "channel_hardware": "T1-3",
      "data_array": "temp",
      "data_index": 3,
      "unit": "℃"
    },
    {
      "control": "label_F_2_2",
      "x": 1008,
      "y": 707,
      "w": 40,
      "h": 12,
      "norm_x": 0.54003,
      "norm_y": 0.80589,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_3",
      "channel_hardware": "A4-3",
      "data_array": "analog",
      "data_index": 3,
      "unit": null
    },
    {
      "control": "label_P_2_2",
      "x": 961,
      "y": 708,
      "w": 40,
      "h": 12,
      "norm_x": 0.51544,
      "norm_y": 0.80698,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "deprecated_pressure",
      "semantics": "★不要复现为压力★ 原按 A4-11..A4-14 当压力显示；这三路已改液位、A4-14 属未启用压缩机。源码保留控件原样但不再刷新，网页端应留空或删除"
    },
    {
      "control": "label_T_2_5",
      "x": 913,
      "y": 707,
      "w": 40,
      "h": 12,
      "norm_x": 0.49032,
      "norm_y": 0.80589,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_7",
      "channel_hardware": "T1-7",
      "data_array": "temp",
      "data_index": 7,
      "unit": "℃"
    },
    {
      "control": "label_T_2_2",
      "x": 805,
      "y": 645,
      "w": 40,
      "h": 12,
      "norm_x": 0.4338,
      "norm_y": 0.73828,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_4",
      "channel_hardware": "T1-4",
      "data_array": "temp",
      "data_index": 4,
      "unit": "℃"
    },
    {
      "control": "label_P_2_1",
      "x": 758,
      "y": 645,
      "w": 40,
      "h": 12,
      "norm_x": 0.40921,
      "norm_y": 0.73828,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "deprecated_pressure",
      "semantics": "★不要复现为压力★ 原按 A4-11..A4-14 当压力显示；这三路已改液位、A4-14 属未启用压缩机。源码保留控件原样但不再刷新，网页端应留空或删除"
    },
    {
      "control": "label_F_2_1",
      "x": 709,
      "y": 645,
      "w": 40,
      "h": 12,
      "norm_x": 0.38357,
      "norm_y": 0.73828,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_2",
      "channel_hardware": "A4-2",
      "data_array": "analog",
      "data_index": 2,
      "unit": null
    },
    {
      "control": "label_T_2_6",
      "x": 809,
      "y": 519,
      "w": 40,
      "h": 12,
      "norm_x": 0.4359,
      "norm_y": 0.60087,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_8",
      "channel_hardware": "T1-8",
      "data_array": "temp",
      "data_index": 8,
      "unit": "℃"
    },
    {
      "control": "label_T_2_7",
      "x": 646,
      "y": 519,
      "w": 40,
      "h": 12,
      "norm_x": 0.3506,
      "norm_y": 0.60087,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_9",
      "channel_hardware": "T1-9",
      "data_array": "temp",
      "data_index": 9,
      "unit": "℃"
    },
    {
      "control": "label_T_2_9",
      "x": 756,
      "y": 221,
      "w": 40,
      "h": 12,
      "norm_x": 0.40816,
      "norm_y": 0.2759,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_11",
      "channel_hardware": "T1-11",
      "data_array": "temp",
      "data_index": 11,
      "unit": "℃"
    },
    {
      "control": "label_T_2_8",
      "x": 629,
      "y": 222,
      "w": 40,
      "h": 12,
      "norm_x": 0.34171,
      "norm_y": 0.27699,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_10",
      "channel_hardware": "T1-10",
      "data_array": "temp",
      "data_index": 10,
      "unit": "℃"
    },
    {
      "control": "label_T_1_3",
      "x": 396,
      "y": 663,
      "w": 40,
      "h": 12,
      "norm_x": 0.21978,
      "norm_y": 0.75791,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T1_2",
      "channel_hardware": "T1-2",
      "data_array": "temp",
      "data_index": 2,
      "unit": "℃"
    },
    {
      "control": "label_T_2_20",
      "x": 1306,
      "y": 256,
      "w": 40,
      "h": 12,
      "norm_x": 0.69597,
      "norm_y": 0.31407,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_0",
      "channel_hardware": "T3-0",
      "data_array": "temp",
      "data_index": 0,
      "unit": "℃"
    },
    {
      "control": "label_T_2_21",
      "x": 1306,
      "y": 344,
      "w": 40,
      "h": 12,
      "norm_x": 0.69597,
      "norm_y": 0.41003,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_1",
      "channel_hardware": "T3-1",
      "data_array": "temp",
      "data_index": 1,
      "unit": "℃"
    },
    {
      "control": "label_T_2_22",
      "x": 1306,
      "y": 432,
      "w": 40,
      "h": 12,
      "norm_x": 0.69597,
      "norm_y": 0.506,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_2",
      "channel_hardware": "T3-2",
      "data_array": "temp",
      "data_index": 2,
      "unit": "℃"
    },
    {
      "control": "label_T_2_23",
      "x": 1306,
      "y": 521,
      "w": 40,
      "h": 12,
      "norm_x": 0.69597,
      "norm_y": 0.60305,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_3",
      "channel_hardware": "T3-3",
      "data_array": "temp",
      "data_index": 3,
      "unit": "℃"
    },
    {
      "control": "label_T_2_24",
      "x": 1306,
      "y": 609,
      "w": 40,
      "h": 12,
      "norm_x": 0.69597,
      "norm_y": 0.69902,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T3_4",
      "channel_hardware": "T3-4",
      "data_array": "temp",
      "data_index": 4,
      "unit": "℃"
    },
    {
      "control": "label_P_1_1",
      "x": 1161,
      "y": 596,
      "w": 40,
      "h": 12,
      "norm_x": 0.62009,
      "norm_y": 0.68484,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_10",
      "channel_hardware": "A4-10",
      "data_array": "analog",
      "data_index": 10,
      "unit": null
    },
    {
      "control": "label_F_1_1",
      "x": 174,
      "y": 695,
      "w": 40,
      "h": 12,
      "norm_x": 0.10361,
      "norm_y": 0.7928,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_0",
      "channel_hardware": "A4-0",
      "data_array": "analog",
      "data_index": 0,
      "unit": null
    },
    {
      "control": "label_F_1_2",
      "x": 156,
      "y": 605,
      "w": 40,
      "h": 12,
      "norm_x": 0.09419,
      "norm_y": 0.69466,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_1",
      "channel_hardware": "A4-1",
      "data_array": "analog",
      "data_index": 1,
      "unit": null
    },
    {
      "control": "label_T_4_8",
      "x": 238,
      "y": 433,
      "w": 40,
      "h": 12,
      "norm_x": 0.1371,
      "norm_y": 0.50709,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_11",
      "channel_hardware": "T2-11",
      "data_array": "temp",
      "data_index": 11,
      "unit": "℃"
    },
    {
      "control": "label_T_4_7",
      "x": 114,
      "y": 433,
      "w": 40,
      "h": 12,
      "norm_x": 0.07221,
      "norm_y": 0.50709,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_10",
      "channel_hardware": "T2-10",
      "data_array": "temp",
      "data_index": 10,
      "unit": "℃"
    },
    {
      "control": "label_T_4_6",
      "x": 237,
      "y": 355,
      "w": 40,
      "h": 12,
      "norm_x": 0.13658,
      "norm_y": 0.42203,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_9",
      "channel_hardware": "T2-9",
      "data_array": "temp",
      "data_index": 9,
      "unit": "℃"
    },
    {
      "control": "label_T_4_5",
      "x": 113,
      "y": 355,
      "w": 40,
      "h": 12,
      "norm_x": 0.07169,
      "norm_y": 0.42203,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_8",
      "channel_hardware": "T2-8",
      "data_array": "temp",
      "data_index": 8,
      "unit": "℃"
    },
    {
      "control": "label_T_4_4",
      "x": 237,
      "y": 277,
      "w": 40,
      "h": 12,
      "norm_x": 0.13658,
      "norm_y": 0.33697,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_7",
      "channel_hardware": "T2-7",
      "data_array": "temp",
      "data_index": 7,
      "unit": "℃"
    },
    {
      "control": "label_T_4_3",
      "x": 113,
      "y": 277,
      "w": 40,
      "h": 12,
      "norm_x": 0.07169,
      "norm_y": 0.33697,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_6",
      "channel_hardware": "T2-6",
      "data_array": "temp",
      "data_index": 6,
      "unit": "℃"
    },
    {
      "control": "label_T_4_2",
      "x": 237,
      "y": 199,
      "w": 40,
      "h": 12,
      "norm_x": 0.13658,
      "norm_y": 0.25191,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_5",
      "channel_hardware": "T2-5",
      "data_array": "temp",
      "data_index": 5,
      "unit": "℃"
    },
    {
      "control": "label_T_4_1",
      "x": 114,
      "y": 198,
      "w": 40,
      "h": 12,
      "norm_x": 0.07221,
      "norm_y": 0.25082,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "T2_4",
      "channel_hardware": "T2-4",
      "data_array": "temp",
      "data_index": 4,
      "unit": "℃"
    },
    {
      "control": "label4",
      "x": 483,
      "y": 100,
      "w": 142,
      "h": 19,
      "norm_x": 0.26531,
      "norm_y": 0.14395,
      "norm_w": 0.07431,
      "norm_h": 0.02072,
      "text_static": "热电偶单位：℃",
      "kind": "legend",
      "semantics": "图例：单位说明，静态文本"
    },
    {
      "control": "label2",
      "x": 483,
      "y": 69,
      "w": 153,
      "h": 19,
      "norm_x": 0.26531,
      "norm_y": 0.11014,
      "norm_w": 0.08006,
      "norm_h": 0.02072,
      "text_static": "压力计单位：KPa",
      "kind": "legend",
      "semantics": "图例：单位说明，静态文本"
    },
    {
      "control": "label1",
      "x": 483,
      "y": 40,
      "w": 163,
      "h": 19,
      "norm_x": 0.26531,
      "norm_y": 0.07852,
      "norm_w": 0.0853,
      "norm_h": 0.02072,
      "text_static": "流量计单位：m³/h",
      "kind": "legend",
      "semantics": "图例：单位说明，静态文本"
    },
    {
      "control": "label_L_1",
      "x": 587,
      "y": 626,
      "w": 40,
      "h": 12,
      "norm_x": 0.31973,
      "norm_y": 0.71756,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_11",
      "channel_hardware": "A4-11",
      "data_array": "analog",
      "data_index": 11,
      "unit": "mm"
    },
    {
      "control": "label_L_2",
      "x": 1145,
      "y": 626,
      "w": 40,
      "h": 12,
      "norm_x": 0.61172,
      "norm_y": 0.71756,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_12",
      "channel_hardware": "A4-12",
      "data_array": "analog",
      "data_index": 12,
      "unit": "mm"
    },
    {
      "control": "label_L_3",
      "x": 907,
      "y": 199,
      "w": 40,
      "h": 12,
      "norm_x": 0.48718,
      "norm_y": 0.25191,
      "norm_w": 0.02093,
      "norm_h": 0.01309,
      "text_static": "-",
      "kind": "sensor_value",
      "channel_key": "A4_13",
      "channel_hardware": "A4-13",
      "data_array": "analog",
      "data_index": 13,
      "unit": "mm"
    }
  ]
} as const;
